$(document).ready(function () {

    var parentElms = $(".main-navigation-item");
    var childElms = $("ul.main-navigation-sub", parentElms);

    parentElms.each(function () {

        var parentElm = $(this);

        var childElm = $("ul.main-navigation-sub", parentElm);

        if (childElm.length > 0) {

            var posRight = (childElm.offset().left + childElm.width());
            var winWidth = $(window).width() - 20;

            if (posRight > winWidth) {
                var leftPos = -(posRight - winWidth);
                childElm.css("left", leftPos + "px");
            }

            var timer;

            parentElm.on("touchstart", function(e) {
                if (!childElm.hasClass('open')) {
                    e.preventDefault();
                    parentElm.trigger('focusin');
                }
            });

            parentElm.on("click", function (e) {
                if (!childElm.hasClass('open')) {
                    e.preventDefault();
                }
            });

            parentElm.on("mouseover focusin", function () {
                
                window.clearTimeout(timer);
                childElms.removeClass('open');
                    childElm.addClass('open');
            });

            parentElm.on("mouseout focusout", function () {
                timer = window.setTimeout(function () {
                    var hasFocus = !!(parentElm.find(':focus').length > 0);
                    if (!hasFocus) {
                        childElm.removeClass('open');
                    }
                }, 800);
            });
        }
    });
});